/* eslint no-unused-vars: 0 */
import ReactDOM from 'react-dom';
import React from 'react';

/* Redux */
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { logger } from './middleware';

/* Polyfill is necessary to work with IE11 */
import 'babel-polyfill';

/* Analytics Handler */
import * as EventHandler from './services/EventHandler';
import FeatureToggleService from './services/FeatureToggleService';

/* FeatureToggle Service */
import { Features } from './data/Features';

/* Reducers */
import reducer from './reducers/default';
import navigation from './reducers/navigation';
import stats from './reducers/stats';

/* Router */
import { Router, Route, Redirect, IndexRoute, browserHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';

/* Sections */
import ConnectedApp from './components/App';
import LandingPage from './components/steps/LandingPage';
import SendMessage from './components/steps/SendMessage';
import ThankYouPage from './components/steps/ThankYouPage';
import ContactDetailsPage from './components/steps/ContactDetailsPage';

import MatchPage from './components/steps/matching/MatchPage';

import StaticFooter from './components/static/StaticFooter';

import Page404 from './components/Page404';

/* Component Wrapper */
import { loadComponent } from './components/steps/HOC/LoadingWrapper';

// Load images to be used inside css files
require('url!../images/arrow_down.png');

// CSS main import
require('../styles/main.scss');
// Cross-browser favicon declaration
require('file?name=favicon.svg!../images/favicon.svg');
// EventHandler start
EventHandler.activate();

// FeatureToggle Service start
const featureToggleService = FeatureToggleService.instance;
featureToggleService.initialiseServiceWithFeatures(Features);

const reducersCombined = combineReducers({
    reducer,
    navigation,
    stats,
    routing: routerReducer,
});

const createStoreWithMiddleware = applyMiddleware(thunk, logger)(createStore);
const store = createStoreWithMiddleware(reducersCombined);

const history = syncHistoryWithStore(browserHistory, store);

history.listen((location) => {
    EventHandler.pageView(location.pathname, window.location.href);
});

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Route path="/" component={ConnectedApp}>
                <IndexRoute components={LandingPage}/>
                <Route path="contact"
                       component={ContactDetailsPage}/>
                <Route path="message"
                       component={loadComponent(SendMessage)}/>
                <Route path="finish"
                       component={ThankYouPage}/>

                <Route path="match" component={MatchPage}/>

                <Route path="*" component={ Page404 }/>
                <Route path="404" component={ Page404 }/>
            </Route>
        </Router>
    </Provider>,
    document.getElementById('app')
);

// Render static footer
ReactDOM.render(
    <div className="app__static__footer">
        <StaticFooter/>
    </div>,
    document.getElementById('static')
);



// WEBPACK FOOTER //
// ./src/index.jsx